import { getSupplier } from '../../../HttpRequests/suppliers';
import { loadSupplier } from '../State/supplier';
import handleException from '../../../Core/Helpers/handleException';
import { getProps } from '../props';

export default () => async (dispatch) => {

  try {
    
    const { id } = getProps().match.params;

    const params = {};

    params.include = [
      'contacts',
      'items',
      'createdBy',
    ].join();

    const response = await getSupplier({ id, params })

    dispatch(loadSupplier(response.data));

  } catch (error) {

    handleException(error);

  }
}
